import React, { Component } from 'react';
import AnimatedNumber from 'react-animated-number';
import Pundi from './Pundi.png';
import CoinId from './CoinId.json';
import CapModal from './CapModal';
import EventModal from './EventModal';


var numeral = require('numeral');
var cryptocurrencies = require('cryptocurrencies');


class TradeCard extends Component {
    constructor(props) {
    super(props);
		this.state = {
            loading: false,	
            capOpen:false,
            eventOpen:false,

            price:0,
            prevPrice:null,
            logoLarge:null,
            website:null,
            twitter:null,

            entry:0,
            target:0,
            asset:0,
            stoploss:0,
            fee:0,
            
            profit:0,
            percent:0,
            request:false,
            summary:false,



            //timer
            time: {
                hours: 0,
                minutes: 0,
                seconds: 0,
                milliseconds: 0,
              },
              duration: 10 * 60 * 1000,
              timer: null
            
          
        };
        this.startTimer = this.start.bind(this);
       // this.add=this.add.bind(this);
    }
    componentDidMount() {
        this._isMounted = true;
      //  if(this.props.coin +'-'+ this.props.currency === this.props.currentGold){
            //console.log('dsd', this.props.coin +'-'+ this.props.currency ,this.props.currentGold,this.props.tradePrice)
      //  }
        this.getLogo();

        if(this.props.trade[1] +'-' + this.props.trade[2] === this.props.currentGold){
            this.startTimer()

        }
        //this.getWebSocket();

    }

    componentDidUpdate(prevProps, prevState) {

        if(prevProps.tradePrice!==this.props.tradePrice){
            
            this.getWebSocket();
           
        }

      

        
        if(prevProps.trade[0]!==this.props.trade[0]){
            this.setState({
                price:0
              },()=> this.getWebSocket());
            this.getLogo();
           
           
        }

        
        if(this.props.tradeDetailRequest){
            this.request(this.state,this.props.trade[1],this.props.trade[2],(((this.state.price - this.state.entry)/this.state.entry)*100))
           
           
        }

        
        if(this.props.requestSummary){
            this.summaryRequest(this.state,this.props.trade[1],this.props.trade[2],(((this.state.price - this.state.entry)/this.state.entry)*100))
           
           
        }

        if(prevProps.listenEntry !== this.props.listenEntry && this.props.trade[1] === this.props.assetTrade){
            this.setState({entry:this.props.listenEntry},()=>console.log())                 
            if(this.props.listenAmount > 0 && this.props.listenEntry > 0 && this.state.asset > 0){
                this.filled()
            }
        }

        if(prevProps.listenAmount !== this.props.listenAmount && this.props.trade[1] === this.props.assetTrade){
            this.setState({asset:this.props.listenAmount},()=>console.log())                 
            if(this.props.listenAmount > 0 && this.props.listenEntry > 0 && this.state.entry > 0){
                this.filled()
            }
        }

        if(prevProps.listenTarget !== this.props.listenTarget && this.props.trade[1] === this.props.assetTrade){
            this.setState({target:this.props.listenTarget},()=>console.log())                 
        }
       
       
      }

    

    componentWillUnmount() {
		this._isMounted = false;
	}
    
    
    getWebSocket(){
        
        let message = this.props.tradePrice
       // console.log(this.props.tradePrice)
        if(message.PRICE !== undefined && message.FROMSYMBOL === this.props.trade[1]){
            this.setState({prevPrice:this.state.price,price:message.PRICE},()=> console.log())          

         }
        // name,sold,entry,amount,closeTrade
         if(message.MESSAGE === "INVALID_SUB"){
            this.props.sell(this.props.currentGold,this.props.onSpent,this.state.entry,this.state.asset,this.props.trade[1] +'~' + this.props.trade[2] ,this.state.time.minutes, this.state.time.seconds)
         }
         else if(this.props.trade[1] +'-' + this.props.trade[2] === this.props.currentGold && this.state.entry === 0 && message.PRICE !== undefined && message.FROMSYMBOL === this.props.trade[1]){
             this.setState({entry:message.PRICE,target:message.PRICE + (message.PRICE * this.props.targetPercent),stoploss:message.PRICE - (message.PRICE * 0.008),fee:message.PRICE - (message.PRICE * 0.002),asset:this.props.onSpent/message.PRICE})
            //console.log('dsd',this.state.entry,this.state.target,this.state.asset)

         }
         else{
           if(this.state.price >= this.state.target && this.state.target !== 0){
               this.sell()
           }
           else if(this.state.price <= this.state.stoploss && this.state.stoploss !== 0){
            this.stopLoss()
           }

         }
        
  
    }

    msToTime(duration) {
        let milliseconds = parseInt((duration % 1000));
        let seconds = Math.floor((duration / 1000) % 60);
        let minutes = Math.floor((duration / (1000 * 60)) % 60);
        let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    
        hours = hours.toString().padStart(2, '0');
        minutes = minutes.toString().padStart(2, '0');
        seconds = seconds.toString().padStart(2, '0');
        milliseconds = milliseconds.toString().padStart(3, '0');
    
        return {
          hours,
          minutes,
          seconds,
          milliseconds
        };
      }


    start() {
        if (!this.state.timer) {
          this.state.startTime = Date.now();
          this.timer = window.setInterval(() => this.run(), 10);
        }
      }

      run() {
        const diff = Date.now() - this.state.startTime;
        
        // If you want to count up
        // this.setState(() => ({
        //  time: this.msToTime(diff)
        // }));
        
        // count down
        let remaining = this.props.tradeDuration - diff;
        if (remaining < 0) {
          remaining = 0;
        }
        this.setState(() => ({
          time: this.msToTime(remaining)
        }));
        if (remaining === 0) {
          window.clearTimeout(this.timer);
          this.timer = null;

          this.expired()
        }
      }

    sell(){
        //console.log('sold',)
        if(this.props.onTrade){
        this.props.sell(this.props.currentGold,this.state.asset * this.state.target,this.state.entry,this.state.asset,this.props.trade[1] +'~' + this.props.trade[2], this.state.time.minutes, this.state.time.seconds)
        }
    }

    stopLoss(){
        if(this.props.onTrade){
            this.props.sell(this.props.currentGold,this.state.asset * this.state.stoploss,this.state.entry,this.state.asset,this.props.trade[1] +'~' + this.props.trade[2], this.state.time.minutes, this.state.time.seconds)
            }
    }

    expired(){
        //console.log('sold',)
        if(this.props.onTrade){
        this.props.sell(this.props.currentGold,this.state.asset * this.state.price,this.state.entry,this.state.asset,this.props.trade[1] +'~' + this.props.trade[2], this.state.time.minutes, this.state.time.seconds)
        }
    }

   
      async getLogo(){

        let ID = CoinId.filter(coin => coin.name === this.props.trade[1])
        let x = ID[0].ID

        if(x !== undefined)
        fetch('https://api.coingecko.com/api/v3/coins/'+x+'?localization=false&tickers=false&market_data=false&community_data=false&developer_data=false&sparkline=false')
        .then(res => res.json())
        .then((data) => {
          if (this._isMounted && data !== undefined){

          this.setState({logo: data.image.small,logoLarge: data.image.large,website: data.links.homepage[0], twitter: data.links.twitter_screen_name},()=>(console.log()))}
        })
        .catch(console.log)
    
      }
      


      round(value){
        if (value){
            if(this.props.trade[2] === 'USDT' ){
            return numeral(this.state.price).format('0,0.0000');
            }
            else{
            return numeral(this.state.price).format('0,0.00000000');
            }
        }
        return 0;
    }

    assetChange = (event) => {
        let asset = event.target.value;
        this.setState({asset:asset},()=>console.log())
    }

    entryChange = (event) => {
        let entry = event.target.value;
        this.setState({entry:entry},()=>console.log())
    }

    targetChange = (event) => {
        let target = event.target.value;
        this.setState({target:target},()=>console.log())
    }

    request(details, name, currency, profit){
        this.setState({request:true},()=>console.log())
        if(this.state.request){
        this.props.speakTradeDetails(details, name, currency, profit)
        this.setState({request:false},()=>console.log())}
    }


    summaryRequest(details, name, currency, profit){
        this.setState({summary:true},()=>console.log())
        if(this.state.summary){
        this.props.summaryRequest(details, name, currency, profit)
        this.setState({summary:false},()=>console.log())}
    }

    filled(){
        this.props.oblivion()     
    }



       
    render() {
      // console.log(this.props.trade[1], this.props.assetTrade, this.props.trade[1] === this.props.assetTrade)
      //  if(this.props.tradeDetailRequest){
           // console.log('details',this.props.tradeDetailRequest)
           // this.request(this.state,this.props.trade[1],this.props.trade[2],(((this.state.price - this.state.entry)/this.state.entry)*100))
           // }
        let logo = Pundi;

        if(this.state.logo !== null){
            logo = this.state.logoLarge;
            
        }
        else{
            logo = Pundi;
        }
        
        let capClose = () => this.setState({capOpen:false})
        let capOpen = () => this.setState({capOpen:true})
        let eventClose = () => this.setState({eventOpen:false})
        let eventOpen = () => this.setState({eventOpen:true})

        let link = 'https://www.binance.com/en/trade/'+ this.props.trade[1] +'_'+this.props.trade[2]
       
        let num=<div className="price">Price: <AnimatedNumber component="text" value={this.state.price} onClick={() => this.setState({ modalOpen:true})} style={{
            transition: '0.1s ease-out',
            fontSize: 15,
            cursor:'pointer',
            transitionProperty:
            'background-color, color, opacity'
            
        }}frameStyle={perc => (
            perc === 100 ? {} : {color: fontColor}
        )}
        duration={1500}
        formatValue={n=>this.round(n)}>Price: {this.state.price}</AnimatedNumber> {this.props.trade[2].slice(0,3)} </div>;
      
    
        let fontColor = 'rgb(245, 237, 237)';
        if(this.state.prevPrice < this.state.price){
            fontColor = 'rgb(98, 175, 34)';
        }
        else if(this.state.prevPrice > this.state.price){
            fontColor = 'rgba(230, 26, 60)';
        }
        else{
            fontColor = 'rgb(154, 236, 87)';
        }
       
        

     
       let body = ''
      
       body =  
      
      
         <div className="cryptoTrades">
             <div className = "row">
             <div className="column3">
              
              <a href={this.state.website} target="blank" className="links" title={this.state.website}> 
              <img src={logo} className="logoTrade" alt=''/>
              </a>
              
              <div className="header" >
                <a href={link} target="blank" className="links" title="Open on Binance"> 
                {this.props.trade[1]}-{this.props.trade[2].slice(0,3)}
                </a>
                </div>
                {num}
                
                <p className="trades" >Entry: {this.state.entry}</p>
                <p className="trades">Asset: {this.state.asset}</p>
                <p className="trades">Amount: ${numeral(this.state.asset * this.state.entry).format('0,00')}</p>
                <p className="trades">Target: {this.state.target}</p>
                <p className="trades">Countdown: {this.state.time.minutes} : {this.state.time.seconds}</p>
                
              </div>
              <div  className="column3 " style={{textAlign:"center"}}>
              <h1 className="tradeAmount">${numeral(this.state.asset * this.state.price).format('0,0.00')}</h1>
              {numeral(((this.state.price - this.state.entry)/this.state.entry)*100).format('0,0.00') > 0 &&<h1 className="tradePositive">+{numeral(((this.state.price - this.state.entry)/this.state.entry)*100).format('0,0.00')}%</h1>}
              {numeral(((this.state.price - this.state.entry)/this.state.entry)*100).format('0,0.00') < 0 &&<h1 className="tradeNegative">{numeral(((this.state.price - this.state.entry)/this.state.entry)*100).format('0,0.00')}%</h1>}
              <h5>P&L: {numeral((this.state.asset * this.state.price) - (this.state.asset * this.state.entry)).format('0,0.00')}</h5>
              <p className="target">Target: ${numeral(this.state.asset * this.state.target).format('0,0.00')} ({numeral(((this.state.target - this.state.entry)/this.state.entry)*100).format('0,0.00')}%)</p>
              </div>

               <div className="column3">
                  <div className="powerButton">
                  <div className="twitter">
                  <i onClick={()=>this.props.removeTrade(this.props.trade)} class="fas fa-power-off"></i>
                  </div>
                  <a className="twitter mt-2" href={"https://twitter.com/"+this.state.twitter} target="blank">
                  <i class="fab fa-twitter"></i>
                  </a>

                  <div className="twitter mt-2">
                  <i class="fas fa-user-astronaut" title={'View Market Cap'}  onClick={() => this.setState({ capOpen:true})}></i>
                  {this.state.capOpen&&<CapModal
                  show={capOpen}
                  onHide={capClose}
                  coinName={this.props.trade[1]}
                  name={cryptocurrencies[this.props.trade[1]]}
                  logo={logo}
                  website={this.state.website}
                  aria-labelledby="ModalHeader"
                  />}
                  </div>

                  <div className="twitter mt-2">
                  <i class="fas fa-calendar-alt" title={'View Events'}  onClick={() => this.setState({ eventOpen:true})}></i>
                    {this.state.eventOpen&&<EventModal
                    show={eventOpen}
                    onHide={eventClose}
                    coinName={this.props.trade[1]}
                    aria-labelledby="ModalHeader"
                    />}
                 </div> 
                
                </div>
   
              </div>
              </div>

             


              <div className = "row">
              <div className="group mt-3 mb-2">
				
						<input className="verify" type="number" min="0"  autoComplete="off" onChange={this.assetChange}/>
                  
                    <p className="trades mt-2" >Asset</p> 
			  </div>

              <div className="group mt-3 mb-2">
				
						<input className="verify" type="number" min="0"  autoComplete="off" onChange={this.entryChange}/>
              
                    <p className="trades mt-2" >Entry</p> 
			  </div>

              <div className="group mt-3 mb-2">
				
						<input className="verify" type="number" min="0"  autoComplete="off" onChange={this.targetChange} />
               
                    <p className="trades mt-2" >Target</p> 
			  </div>
              </div>
              
         
       </div>
       
          
    
        return (
            
            <div>

                {body} 

            </div>
            
        );
    }
}

export default TradeCard;